<template>
    <div>
        <v-card height="100%">
            <v-toolbar flat height="unset" class="py-2">
                <p class="line" style="margin: 0"></p>
                <v-toolbar-title class="pl-4 subtitle-1 font-weight-bold ma-0 primary--text" style="white-space: normal;">
                    Proyección
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="userAtLeastIs(user, LEVEL_ADMIN)"
                    :disabled="!period || !date_start || !date_end || !rate"
                    :loading="simulate.status == 'loading'"
                    color="accent" 
                    small 
                    @click="doSimulation"
                    class="mr-3">Simular</v-btn>
                <v-btn
                    v-if="userAtLeastIs(user, LEVEL_ADMIN)"
                    :disabled="!changes"
                    color="accent" 
                    @click="save"
                    small>
                    <v-icon>mdi-content-save</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col> 
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col cols="6">
                                        <v-menu
                                            :disabled="!userAtLeastIs(user, LEVEL_ADMIN)"
                                            ref="start"
                                            v-model="start_menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date_start"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="date_start_formated"
                                                hide-details
                                                dense
                                                outlined
                                                flat
                                                label="Fecha inicial"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date_start" no-title scrollable @input="changes = true" locale="es">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="start_menu = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.start.save(date_start)">OK</v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="date_end_formated"
                                            dense
                                            outlined
                                            flat
                                            hide-details
                                            label="Fecha final"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" >
                                <v-select
                                    v-if="userAtLeastIs(user, LEVEL_ADMIN)"
                                    v-model="period"
                                    :items="[{
                                        text: 'Bimestral',
                                        value: 2
                                    },{
                                        text: 'Mensual',
                                        value: 1
                                    }]"
                                    @change="changes = true"
                                    label="Periodo"
                                    dense
                                    hide-details
                                    outlined
                                    flat
                                    solo
                                ></v-select>
                                <v-text-field
                                    v-else
                                    label="Periodo"
                                    dense
                                    outlined
                                    flat
                                    hide-details
                                    readonly
                                    :value="period === 1 ? 'Mensual': 'Bimestral'"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-select
                                    v-if="userAtLeastIs(user, LEVEL_ADMIN)"
                                    v-model="rate"
                                    :items="rates"
                                    item-text="name"
                                    item-value="name"
                                    @change="changes = true"
                                    label="Tarifa"
                                    hide-details
                                    dense
                                    outlined
                                    flat
                                    solo
                                ></v-select>
                                <v-text-field
                                    v-else
                                    v-model="rate"
                                    label="Tarifa"
                                    dense
                                    outlined
                                    flat
                                    hide-details
                                    readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="d-flex">
                        <div class="text-center ma-auto" v-if="!simulate.status">
                            <v-icon x-large color="accent">mdi-chart-box-plus-outline</v-icon>
                            <p class="my-0">Ingresar datos</p>
                        </div>
                        <div class="text-center ma-auto" v-else-if="simulate.status === 'no-data'">
                            <v-icon x-large color="accent">mdi-chart-box-plus-outline</v-icon>
                            <p class="my-0">Sin datos de consumo</p>
                        </div>
                        <div v-else class="text-center ma-auto">
                            <p class="font-weight-bold mb-1">Se estima un monto a pagar de</p>
                            <p class="text-h5 font-weight-bold accent--text mt-1 simulate-text" v-if="simulate.status === 'done'"> 
                                <span class="ma-1">$</span> {{simulate.value}} <span class="ma-1">MXN</span> 
                            </p>
                            <p v-else>
                                <v-icon>mdi-dots-horizontal</v-icon>
                            </p>
                        </div>
                    </v-col>
                </v-row>
                
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { FIXED, PROPORTIONAL } from '../../plugins/rates'
import { userAtLeastIs, LEVEL_ADMIN } from '../../plugins/checkPermission'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'simulator',
    props: ['gateway', 'meters'],
    computed:{
        ...mapState({
            rates: state => state.account.profile.rates,
            user: state => state.user.profile.level
        }),
        date_start_formated(){
            if(!this.date_start ) return
            let date = new Date(this.date_start)
            date.setTime(date.getTime() + (1000 * 60 * 60 * 6))
            const [year, month, day] = date.toISOString().substr(0, 10).split('-')
            return `${day}/${month}/${year}`
        },
        date_end(){
            if(!this.date_start || !this.period) 
                return null
            let date = new Date(this.date_start)
            date.setMonth(date.getMonth() + this.period)
            date.setTime(date.getTime() + (1000 * 60 * 60 * 6))
            return date.toISOString().substr(0, 10)
        },
        date_end_formated(){
            if(!this.date_start || !this.period) 
                return null
            let date = new Date(this.date_start)
            date.setMonth(date.getMonth() + this.period)
            date.setTime(date.getTime() + (1000 * 60 * 60 * 6))
            const [year, month, day] = date.toISOString().substr(0, 10).split('-')
            return `${day}/${month}/${year}`
        }
    },
    data() {
        return {
            simulate:{
                status: null,
                value: 0
            },
            date_start: null,
            start_menu: null,
            rate: null,
            period: null,
            changes: false,
            LEVEL_ADMIN,
            FIXED, PROPORTIONAL
        }
    },
    methods:{
        ...mapActions({ 
            saveChanges: 'gateways/saveSimulation',
            queryReadings: 'meters/queryReadings',
            getSummaryData: 'meters/getSummaryData'
        }),
        userAtLeastIs,
        setData(){
            if(!this.gateway.rate) return null
            this.simulate.status = null
            this.simulate.value = 0
            this.rate = this.gateway.rate
            this.period = this.gateway.period
            this.date_start = this.gateway.start_period
            this.changes = !this.period || !this.date_start || !this.date_end || !this.rate ? true: false
            this.checkDateStart()
            if(this.date_start && this.rate && this.period)
                this.doSimulation()
        },
        checkDateStart(){
            if(!this.date_start) return
            const date = new Date(this.date_start)
            date.setMonth(date.getMonth() + this.period)
            date.setTime(date.getTime() + (1000 * 60 * 60 * 6))
            
            if(new Date().getTime() < date.getTime())
                return
            
            this.date_start = date.toISOString().substr(0, 10)
            this.save()
        },
        async doSimulation(){
            this.simulate.status = 'loading'

            const meters_consum = this.meters.filter(m => m.type === 'consumption')
            if(meters_consum.lenght === 0){
                this.simulate.status = 'no-data'
                return
            }

            try {
                const rate = this.rates.find( r => r.name === this.rate )
                const consumption = await this.calculatePriceConsumption(meters_consum, rate.price)
                const base = this.calculatePriceBase(rate)
                const demand = await this.calculatePriceDemand(meters_consum, rate)

                this.simulate.value = (parseFloat(consumption) + parseFloat(base) + parseFloat(demand)).toFixed(2)
                this.simulate.status = 'done'
            } catch (error) {
                console.log(error)
                this.simulate.status = null
            }
        },
        async calculatePriceConsumption(meters, price){
            const [ start_y, start_m, start_d ] = this.date_start.split('-')
            const start_day = new Date()
            start_day.setHours(0,0,0,0)
            start_day.setFullYear(start_y, start_m - 1, start_d)
            
            const [ end_y, end_m, end_d ] = this.date_end.split('-')
            const end_day = new Date()
            end_day.setHours(0,0,0,0)
            end_day.setFullYear(end_y, end_m - 1, end_d)
            
            const start_req = meters.map( meter => 
                this.queryReadings({ 
                    meter: meter.id, 
                    query: { start: start_day, len: 1 }
                })
            )
            const start_responses = await Promise.all(start_req)
            const start_kwh = start_responses.reduce((suma, response) => {
                if(response.status !== 200) return suma
                if(response.data.data.length === 0) return suma
                return suma + response.data.data[0].data.measurement.netKwh
            }, 0)

            const end_req = meters.map( meter => 
                this.queryReadings({ meter: meter.id, query: { len: 1 }})
            )
            const end_responses = await Promise.all(end_req)
            const end_kwh = end_responses.reduce((suma, response) => {
                if(response.status !== 200) return suma
                if(response.data.data.length === 0) return suma
                return suma + response.data.data[0].data.measurement.netKwh
            }, 0)

            const DAY = 1000 * 60 * 60 * 24
            const total_days = Math.round((end_day.getTime() - start_day.getTime()) / DAY)
            const current_days = Math.round((new Date().getTime() - start_day.getTime()) / DAY)
            const kwh_day = (end_kwh - start_kwh) / current_days

            const current_cons = (end_kwh - start_kwh) * price
            const estimate_next_cons = (total_days - current_days) * kwh_day * price
            const total_consumption = current_cons + estimate_next_cons

            return (total_consumption).toFixed(2)
        },
        calculatePriceBase(rate){
            return rate.base && (rate.rate === FIXED || rate.rate === PROPORTIONAL)
                ? rate.base
                : 0
        },
        async calculatePriceDemand(meters, rate){
            if(rate.rate !== this.PROPORTIONAL || !rate.demand) return 0

            const [ start_y, start_m, start_d ] = this.date_start.split('-')
            const start_day = new Date()
            start_day.setHours(0,0,0,0)
            start_day.setFullYear(start_y, start_m - 1, start_d)

            const responses = await this.getSummaryData({ 
                meters: meters, 
                type: 'year', 
                start: start_day
            })
            
            let max_watts = 0
            responses.forEach( response => {
                const data = response.data.data
                data.forEach( month => 
                    max_watts = month.measurements.totalPower.max > max_watts
                        ? month.measurements.totalPower.max
                        : max_watts
                )
            })
            
            const demand = (max_watts / 1000) * parseFloat(rate.demand)
            return demand
        },
        async save(){
            try {
                await this.saveChanges({
                    gateway: this.gateway.id ,
                    period: this.period,
                    rate: this.rate,
                    start: this.date_start
                })
                this.changes = false
            } catch (error) {
                console.log(error)
            }
        }
    },
    watch:{
        gateway(){
            this.setData()
        }
    },
    mounted(){
        this.setData()
    }
}
</script>

<style scoped>
    .line{
        border-left: 2px solid var(--v-primary-base);
        height: 13px;
    }
    .simulate-text{
        display: inline-flex;
        align-items: center;
    }
    .simulate-text > span {
        font-size: 15px;
    }
</style>